import { createTheme, ThemeProvider } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    scoreLevels: {
      excellent: string;
      good: string;
      average: string;
      poor: string;
      veryPoor: string;
    };
    scoreText: {
      good: string;
      average: string;
      poor: string;
    };
    sentiment: {
      pos: string;
      neg: string;
    };
    siteColors: {
      amazon: string;
      rakuten: string;
      yahoo: string;
      himaraya: string;
      supersports: string;
    };
    rankColors: {
      gold: string;
      silver: string;
      bronze: string;
      gray: string;
    };
    border: {
      light: string;
      white: string;
    };
    shadow: {
      card: string;
    };
  }

  interface PaletteOptions {
    scoreLevels?: {
      excellent?: string;
      good?: string;
      average?: string;
      poor?: string;
      veryPoor?: string;
    };
    scoreText?: {
      good?: string;
      average?: string;
      poor?: string;
    };
    sentiment?: {
      pos?: string;
      neg?: string;
    };
    siteColors?: {
      amazon?: string;
      rakuten?: string;
      yahoo?: string;
      himaraya?: string;
      supersports?: string;
    };
    rankColors?: {
      gold?: string;
      silver?: string;
      bronze?: string;
      gray?: string;
    };
    border?: {
      light?: string;
      white?: string;
    };
    shadow?: {
      card?: string;
    };
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: '#143282',
    },
    secondary: {
      main: '#006ED2',
    },
    scoreLevels: {
      excellent: '#4caf50',
      good: '#dcedc8',
      average: '#fff3e0',
      poor: '#ffcdd2',
      veryPoor: '#e57373',
    },
    scoreText: {
      good: '#1b5e20',
      average: '#ef6c00',
      poor: '#D32F2F',
    },
    sentiment: {
      pos: '#4caf50',
      neg: '#e57373',
    },
    siteColors: {
      amazon: '#FF9900',
      rakuten: '#BF0000',
      yahoo: '#FF0033',
      himaraya: '#005BAC',
      supersports: '#1B4DB6',
    },
    rankColors: {
      gold: '#FFD700',
      silver: '#C0C0C0',
      bronze: '#cd7f32',
      gray: '#808080',
    },
    border: {
      light: '#ddd',
      white: '#ffffff',
    },
    shadow: {
      card: 'rgba(0, 0, 0, 0.1)',
    },
  },
});

export function Theme({ children }: { children: React.ReactNode }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
